<template>
	<div class="transcription">
		<!-- <div class="t-header">
			<div class="t-h-title">实时转录</div>
			<div class="t-h-time">{{ data.time }}</div>
		</div> -->
		<div class="t-content">
			{{ data.content?data.content:"暂无..." }}
			<span v-if="showGetTextLoading">_（转译中...）</span>
			<!-- <div class="contentCon" v-for="(i, index) in chatList" :key="index">
				<div class="conTim">{{ i.timer }}</div>
				<div class="conTxt">
					{{ i.con }}
				</div>
			</div> -->
		</div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			default: () => {
				return {};
			},
		},
		showGetTextLoading:{
			type:Boolean,
			default:false,
		}
	},
	data() {
		return {
			chatList: [
				{
					timer: "[00:00]",
					con: "请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文",
				},
				{
					timer: "[05:00]",
					con: "请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文",
				},
				{
					timer: "[10:00]",
					con: "请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文",
				},
				{
					timer: "[15:00]",
					con: "请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文",
				},
				{
					timer: "[20:00]",
					con: "请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文",
				},
				{
					timer: "[25:00]",
					con: "请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文",
				},
				{
					timer: "[30:00]",
					con: "请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字这里是语音同步转文字请用日常生活为主题，跟我进行英语对话，这里是语音同步转文字，这里是语音同步转文",
				},
			],
		};
	},
};
</script>

<style scoped>
.transcription {
	width: 100%;
	height: 100%;
	/* height: calc(100vh - 300px); */
	max-height: calc(100vh - 300px);
	position: relative;
	/* display: flex; */
	/* flex-direction: column; */
	/* overflow: auto; */
	/* padding-top:30px; */
}
.contentCon {
	display: flex;
	justify-content: flex-start;
}
.conTim {
	flex-shrink: 0;
	margin-right: 10px;
	line-height: 32px;

	color: rgba(54, 129, 252, 1);
}
.conTxt {
	font-family: PingFang SC;
	font-size: 16px;
	font-weight: 400;
	line-height: 32px;
	text-align: left;
}
.t-content {
	width: 100%;
	flex: 1;
	/* height: 50%; */
	height: calc(100vh - 290px);
	padding: 20px 30px;
	box-sizing: border-box;
	overflow: auto;
	word-break: break-all;
}

.t-header {
	width: 100%;
	height: 40px;
	display: flex;
	align-items: center;
}
.t-h-title {
	font-size: 20px;
	font-weight: bold;
	margin-right: 10px;
}
.t-h-time {
	font-size: 14px;
	color: #aeafb1;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/transcription.vue